export default "__VITE_ASSET__BlTKdckD__"